/**
 * 請求画面の表示フォーマット。
 * データ取得（billingApi）から独立した純粋関数のみを置く。
 */

import { BillingCycle } from "./types";

/** 円表示（3桁区切り）。負値は -¥1,234 */
export const yen = (v: number): string =>
  (v < 0 ? "-¥" : "¥") + Math.abs(Math.round(v)).toLocaleString();

/** 支払方法ラベル */
export const cycleLabel = (c: BillingCycle): string =>
  c === "annual_lump" ? "年一括払い" : "月額払い";

/** 年度（4月始まり）を返す。1〜3月は前年の年度。 */
export const fiscalYear = (year: number, month: number): number =>
  month >= 4 ? year : year - 1;

/**
 * 請求書ID（`{service}-{year}-{mm}`）を分解する。
 * 形式が不正な場合は null。
 */
export const parseInvoiceId = (id: string): { ym: string } | null => {
  const matched = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(id);
  if (!matched) return null;
  return { ym: `${matched[1]}-${matched[2]}` };
};
